export default __webpack_public_path__ + "static/media/AvenirNext-Regular.8ca99718.woff2";